<app-page-content class="madar--v2" [showBreadcrumb]="false">
  <div content>
    <app-tab
      [tabs]="tabs"
      [theme]="'trapezoid'"
      [backgroundTransparent]="false"
      [selectedIndex]="selectedIndex"
      (currentIndex)="onTabIndexChanged($event)"
    ></app-tab>
      <mat-card>
        <mat-card-content>
          <div [formGroup]="form" class="flex align-center justify-space-between py-1">
            <div class="flex align-center">
              <app-search-input
                [showSearchActions]="false" 
                [placeholder]="'Placeholder.Search' | translate"
                [iconPosition]="'right'" 
                [multiple]="false" 
                (searchValue)="setFilterParams({ searchTerm: $event })"
              ></app-search-input>
              <app-date-range
                class="ml-4"
                size="sm"
                showIcon="true"
                appearance="fill"
                formControlName="dateRange"
                [showCustomDateOption]="true"
              ></app-date-range>
            </div>

            <app-export-button
              *ngIf="dataSource.data.length"
              (buttonClicked)="onExportClicked()"
            ></app-export-button>
          </div>
  
          <div class="mt-3">
            <app-entity-listing
              [pageIndex]="filters.params.offset + 1"
              [pageSize]="filters.params.limit"
              (pageIndexChanged)="setFilterParams({ offset: $event - 1 })"
              (pageSizeChange)="setFilterParams({ limit: $event, offset: 0 })"
              [state]="sectionState"
              [totalCount]="totalRowsCount"
              [selectionEnabled]="true"
              [emptyStateMainLabel]="'sharedFeatures.NoStatementsFound' | translate"
            >
              <table mat-table class="table scrollable scrollable--x" [dataSource]="dataSource">
                <ng-container matColumnDef="createdAt">
                  <th mat-header-cell *matHeaderCellDef>{{ 'sharedFeatures.TransactionDate' | translate }}</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element?.createdAt | date: 'MMM d, y' }}
                  </td>
                </ng-container>
  
                <ng-container matColumnDef="referenceId">
                  <th mat-header-cell *matHeaderCellDef>{{ 'sharedFeatures.ReferenceNumber' | translate }}</th>
                  <td mat-cell *matCellDef="let element" [ngClass]="{ 'cell-no-data': !element?.referenceId }">
                    {{ element?.referenceId }}
                  </td>
                </ng-container>
  
                <ng-container matColumnDef="dueDate">
                  <th mat-header-cell *matHeaderCellDef>{{ 'sharedFeatures.DueDate' | translate }}</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element?.dueDate | date: 'MMM d, y' }}
                  </td>
                </ng-container>
  
                <ng-container matColumnDef="overdueDays">
                  <th mat-header-cell *matHeaderCellDef>{{ 'sharedFeatures.OverdueDays' | translate }}</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element?.overdueDays }}
                  </td>
                </ng-container>
  
                <ng-container matColumnDef="debit">
                  <th mat-header-cell *matHeaderCellDef>{{ 'sharedFeatures.Debit' | translate }}</th>
                  <td mat-cell *matCellDef="let element" [ngClass]="{ 'cell-no-data': element?.type !== accountStatementType.Debit }">
                    <span class="text-warn" *ngIf="element?.type === accountStatementType.Debit">
                      - {{ element?.amount | number: '1.2-2' }}
                    </span>
                  </td>
                </ng-container>
  
                <ng-container matColumnDef="credit">
                  <th mat-header-cell *matHeaderCellDef>{{ 'sharedFeatures.Credit' | translate }}</th>
                  <td mat-cell *matCellDef="let element" [ngClass]="{ 'cell-no-data': element?.type !== accountStatementType.Credit }">
                    <span class="text-success" *ngIf="element?.type === accountStatementType.Credit">
                      + {{ element?.amount | number: '1.2-2' }}
                    </span>
                  </td>
                </ng-container>
  
                <ng-container matColumnDef="transactionStatus">
                  <th mat-header-cell *matHeaderCellDef>{{ 'sharedFeatures.Status' | translate }}</th>
                  <td mat-cell *matCellDef="let element">
                    <app-rect-tag [color]="colorPerStatus[element?.transactionStatus]">
                      {{ ('Tab.' + element?.transactionStatus) | translate }}
                    </app-rect-tag>
                  </td>
                </ng-container>
  
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
              </table>
            </app-entity-listing>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
</app-page-content>
